export const GLOBAL_CTAS_STICKY_FOOTER_FLAG_NAME = 'pen-5032_v1'
